import { ANSWERS } from '../constants/select-answers.constant';

export const isStringEqual = (inputString) => {
	return Object.values(ANSWERS).some((answerGroup) => {
		return answerGroup.some((answer) => answer.value.includes(inputString));
	});
};
